import React, { createContext, useState, useContext, useEffect } from 'react';
import { isAuthenticated, logout as logoutService } from '../services/authService';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is authenticated on mount
    setIsAdmin(isAuthenticated());
    setLoading(false);
  }, []);

  const login = () => {
    setIsAdmin(true);
  };

  const logout = () => {
    logoutService();
    setIsAdmin(false);
  };

  const value = {
    isAdmin,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
